export { default } from './MaoNaRoda25Banner';
